// components
import GridPageAbstract from '../../abstract/GridPageAbstract';
import { MenuItem } from '@mui/material';
import InfoIcon from '@mui/icons-material/Info';
import i18n from '../../../i18n';
import { Archive } from '@mui/icons-material';
import React from 'react';

export default class MerchantsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'publicMerchants';
        this.Server = this.props.context.getState().server.publicMerchants;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['name', 'phone', 'email'];
        this.showTotalRow = true;
        this.exportButton = true;
        this.hasCustomLogicOnMount = true;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'name',
                    label: 'name',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'phone',
                    label: 'phone',
                    alignRight: false,
                    cell: 'Phone',
                    displayGrid: true
                },
                {
                    id: 'email',
                    label: 'email',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'uuid',
                    label: 'uuid',
                    alignRight: false,
                    cell: 'Text',
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'TextDetails'
                },
                {
                    id: 'apiKey',
                    label: 'apiKey',
                    alignRight: false,
                    cell: 'Text',
                    disableEditor: true,
                    displayDialogDetails: true,
                    details: 'TextDetails'
                },
                {
                    id: 'cabinetPass',
                    label: 'cabinetPass',
                    alignRight: false,
                    cell: 'Text',
                    displayDialogDetails: true,
                    details: 'Text',
                    disableEditor: true
                },
                {
                    id: 'modifiedReason',
                    label: 'modifiedReason',
                    alignRight: false,
                    cell: 'BigText',
                    displayGrid: true,
                    disableEditor: true,
                },
                {
                    id: 'modifiedBy',
                    label: 'modifiedBy',
                    alignRight: false,
                    cell: 'Select',
                    object: 'modifiedBy',
                    show: 'firstName+lastName',
                    displayGrid: true,
                    disableEditor: true,
                    customSort: 'modifiedBy.firstName',
                },
                {
                    id: 'dateCreatedModified',
                    elements: ['dateCreated', 'dateModified'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'dateCreated',
                },
                {
                    id: 'totalPaymentsBalance',
                    label: 'totalPaymentsBalance',
                    alignRight: false,
                    cell: 'Amount',
                    total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true,
                },
                {
                    id: 'totalPayoutsBalance',
                    label: 'totalPayoutsBalance',
                    alignRight: false,
                    cell: 'Amount',
                    total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true,
                },
                {
                    id: 'totalFees',
                    label: 'totalFees',
                    alignRight: false,
                    cell: 'Amount',
                    total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true,
                },
                {
                    id: 'totalDepositsBalance',
                    label: 'totalDepositsBalance',
                    alignRight: false,
                    cell: 'Amount',
                    total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true,
                },
                {
                    id: 'totalWithdrawalsBalance',
                    label: 'totalWithdrawalsBalance',
                    alignRight: false,
                    cell: 'Amount',
                    total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true,
                },
                {
                    id: 'currentBalance',
                    label: 'currentBalance',
                    alignRight: false,
                    cell: 'Amount',
                    total: true,
                    displayGrid: true,
                    disableEditor: true,
                    disableSort: true,
                }
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }

    customLogicOnMount() {
        this.fs.clearGroup('prefilterBase')
            .addFilter('isArchived', '!=', true, 'prefilterBase', true);
    }

    renderCustomMenuItems() {
        const isItemArchived = this.getMenuClickItemValue('isArchived') === true;

        const isAllowedArchive = this.allowedArchive() && !isItemArchived;
        return [
            <MenuItem key="showDetails" onClick={(event) => this.handleShowDialogDetails(event)}>
                <InfoIcon sx={{ mr: 2, width: '20px' }} />
                {i18n.t('common.showDetails')}
            </MenuItem>,
            isAllowedArchive && (
                <MenuItem
                    key="archive"
                    onClick={() => this.handleArchiveConfirmDialogOpen()}
                >
                    <Archive sx={{ mr: 2, width: '20px' }} />
                    {i18n.t('common.archive')}
                </MenuItem>
            )
        ];
    }
}
